import * as React from "react";
import { Menu, MenuItemLink, useSidebarState } from "react-admin";
import { ListItem, ListItemText, Collapse, Divider } from "@mui/material";
import { Folder, ExpandLess, ExpandMore } from "@mui/icons-material";
import { People } from "@mui/icons-material";
//import PublicIcon from '@mui/icons-material/Public';
import ViewListIcon from '@mui/icons-material/ViewList';
import { Tooltip } from "@mui/material";

//3 Ludoteche 0/3
//
//4 Ludoteche 3/6
//
//5 Ludoteche 6/10
//
//6 Ludoteche 10/14

export const MyMenu = () => {
  const [openSpazio, setOpenSpazio] = React.useState(true);
  const [openCentroBF, setOpenCentroBF] = React.useState(true);
  const [openLudo03, setOpenLudo03] = React.useState(true);
  const [openLudo36, setOpenLudo36] = React.useState(true);
  const [openLudo610, setOpenLudo610] = React.useState(true);
  const [openLudo1014, setOpenLudo1014] = React.useState(true);
  const [openExtra, setOpenExtra] = React.useState(true);
  
  const [sidebarIsOpen] = useSidebarState();
  return (
  <Menu 
  sx={{
    width: sidebarIsOpen ? 400 : 70,   // larghezza quando è aperto/chiuso
    minWidth:sidebarIsOpen ? 400 : 70,
    "& .RaMenuItemLink-root": { fontSize: "0.9rem"}
  }}
>
    {/* Dashboard */}
    <Menu.DashboardItem />

    {/* Risorse standard */}
    <Menu.ResourceItem name="users" />
    
    <Menu.ResourceItem name="enti" /> 
    <Menu.ResourceItem name="slots" /> 
    <Menu.ResourceItem name="genitori" /> 
    <Menu.ResourceItem name="bambini" /> 
    <Menu.ResourceItem name="accompagnatori" /> 

    {/**<Divider sx={{ my: 1 }} /> */}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("1") ? (
       <Tooltip title="Spazio Gioco" placement="right">            
        <ListItem button 
          onClick={() => setOpenSpazio(!openSpazio)}>
            <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
            <ListItemText primary="Spazio Gioco" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
        letterSpacing: "0.00938em"}} />
            {openSpazio ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
          </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("1") ? (
      <Collapse in={openSpazio} timeout="auto" unmountOnExit>        
        <MenuItemLink
          to="/iscrizioni" primaryText="Iscrizioni" 
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/prenotazioni" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/titoli" primaryText="Titoli"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
      </Collapse>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("2") ? (
      <Tooltip title="Centro Bambini-Famiglie" placement="right">
          <ListItem button 
          onClick={() => setOpenCentroBF(!openCentroBF)}>
            <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
            <ListItemText primary="Centro Bambini-Famiglie" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
        letterSpacing: "0.00938em"}} />
            {openCentroBF ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
          </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("2") ? (
      <Collapse in={openCentroBF} timeout="auto" unmountOnExit>        
        <MenuItemLink
          to="/iscrizioni_2" primaryText="Iscrizioni" 
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/prenotazioni_2" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/titoli_2" primaryText="Titoli"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
      </Collapse>
    ):(<></>)}

     {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("3") ? (
      <Tooltip title="Ludoteche 0/3" placement="right">
        <ListItem button 
        onClick={() => setOpenLudo03(!openLudo03)}>
          <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
          <ListItemText primary="Ludoteche 0/3" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
      letterSpacing: "0.00938em"}} />
          {openLudo03 ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
        </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("3") ? (
      <Collapse in={openLudo03} timeout="auto" unmountOnExit>        
        <MenuItemLink
          to="/iscrizioni_3" primaryText="Iscrizioni" 
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/prenotazioni_3" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/titoli_3" primaryText="Titoli"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
      </Collapse>
    ):(<></>)}      

  {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("4") ? (
     <Tooltip title="Ludoteche 3/6" placement="right">
          <ListItem button 
          onClick={() => setOpenLudo36(!openLudo36)}>
            <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
            <ListItemText primary="Ludoteche 3/6" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
        letterSpacing: "0.00938em"}} />
            {openLudo36 ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
          </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("4") ? (
      <Collapse in={openLudo36} timeout="auto" unmountOnExit>        
        <MenuItemLink
          to="/iscrizioni_4" primaryText="Iscrizioni" 
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/prenotazioni_4" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/titoli_4" primaryText="Titoli"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
      </Collapse>
    ):(<></>)}  




{localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("5") ? (
      <Tooltip title="Ludoteche 6/10" placement="right">
          <ListItem button 
          onClick={() => setOpenLudo610(!openLudo610)}>
            <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
            <ListItemText primary="Ludoteche 6/10" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
        letterSpacing: "0.00938em"}} />
            {openLudo610 ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
          </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("5") ? (
      <Collapse in={openLudo610} timeout="auto" unmountOnExit>        
        <MenuItemLink
          to="/iscrizioni_5" primaryText="Iscrizioni" 
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/prenotazioni_5" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/titoli_5" primaryText="Titoli"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
      </Collapse>
    ):(<></>)}  
      

     

      {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("6") ? (
      <Tooltip title="Ludoteche 10/14" placement="right">
          <ListItem button 
          onClick={() => setOpenLudo1014(!openLudo1014)}>
            <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
            <ListItemText primary="Ludoteche 10/14" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
        letterSpacing: "0.00938em"}} />
            {openLudo1014 ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
          </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("6") ? (
      <Collapse in={openLudo1014} timeout="auto" unmountOnExit>        
        <MenuItemLink
          to="/iscrizioni_6" primaryText="Iscrizioni" 
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/prenotazioni_6" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
        <MenuItemLink
          to="/titoli_6" primaryText="Titoli"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />
      </Collapse>
    ):(<></>)}  

{localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("7") ? (
      <Tooltip title="Extra" placement="right">
          <ListItem button 
          onClick={() => setOpenExtra(!openExtra)}>
            <People sx={{color: "rgba(0, 0, 0, 0.54)"}}/>
            <ListItemText primary="Extra" sx={{  pl: 2 , fontFamily: "Roboto, Helvetica, Arial, sans-serif", 
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5, color: "rgba(0, 0, 0, 0.6)",
        letterSpacing: "0.00938em"}} />
            {openExtra ? <ExpandLess sx={{color: "rgba(0, 0, 0, 0.54)"}}/> : <ExpandMore sx={{color: "rgba(0, 0, 0, 0.54)"}}/>}
          </ListItem>
      </Tooltip>
    ):(<></>)}
    {localStorage.getItem("ambiti") !== null && localStorage.getItem("ambiti").includes("7") ? (
      <Collapse in={openExtra} timeout="auto" unmountOnExit>              
        <MenuItemLink
          to="/prenotazioni_7" primaryText="Prenotazioni"
          sidebarIsOpen={sidebarIsOpen}
          sx={{ pl: 2 }}
          leftIcon={<ViewListIcon />}
        />      
      </Collapse>
    ):(<></>)}  


    {/* Gruppo: Ambito 2 
    <Menu.SubMenu name="spazio" label="Spazio Gioco">
      <Menu.Item />
      <Menu.Item  />
      <Menu.Item  />
    </Menu.SubMenu>
  */}

    {/* Gruppo: Ambito 3 
    <Menu.SubMenu name="citta" label="Città">
      <Menu.Item to="/torino" primaryText="Torino" />
      <Menu.Item to="/milano" primaryText="Milano" />
    </Menu.SubMenu>*/}

    {/* Gruppo: Ambito 4 
    <Menu.SubMenu name="auto" label="Auto">
      <Menu.Item to="/mercedes" primaryText="Mercedes" />
      <Menu.Item to="/bmw" primaryText="BMW" />
    </Menu.SubMenu>*/}
  </Menu>
);
};